import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { formatRemainingTime } from "../../../Utils/Helper/Helper";
import { Button, Popover, Radio } from "antd";
import { separate } from "../../../Seprate/Seprate";
import home from "../Home2.module.css";
import { errorToast, succToast } from "../../../Toast/Toast";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { payBarestHelpInstallment } from "../../../Api/ClientServices";
const Installments = ({ item }) => {
  const [loadingState, setLoadingState] = useState(false);
  const [paymentTypeState, setPaymentTypeState] = useState("pgw");
  const payFacturHandler = () => {
    setLoadingState(true);
    const info = {
      id: item?.id,
      payment_type: paymentTypeState,
    };
    payBarestHelpInstallment(info, (succ, res) => {
      if (res.status === 1) {
        succToast("درخواست شما ثبت شد");
        if (paymentTypeState === "pgw") {
          window.open(res.link, "_self");
        }
        setTimeout(() => {
          window.location.reload();
        }, 100);
        setLoadingState(false);
      } else {
        errorToast(res.message);
        setLoadingState(false);
      }
    });
  };
  const paymentType = (
    <div className={home.paymentHolder}>
      <Radio.Group
        onChange={(e) => setPaymentTypeState(e.target.value)}
        value={paymentTypeState}
        style={{
          display: "flex",
          flexDirection: "column",
          direction: "rtl",
          width: "100%",
        }}
        options={[
          { value: "wallet", label: "کیف پول" },
          { value: "pgw", label: "پرداخت آنلاین" },
          { value: "debt", label: "کمک برست" },
        ]}
      />
      <Button
        type="primary"
        onClick={payFacturHandler}
        loading={loadingState}
        disabled={loadingState}
      >
        پرداخت
      </Button>
    </div>
  );
  return (
    <>
      <p>
        <FontAwesomeIcon icon={faExclamationCircle} color="rgb(197, 0, 82)" />{" "}
        {formatRemainingTime(item?.awaiting_time)}
      </p>
      {/* <button className={home.deptBtnPayHolder}>پرداخت {separate(item?.amount)} تومان</button> */}
      <Popover
        overlayInnerStyle={{ direction: "rtl" }}
        destroyTooltipOnHide={true}
        content={paymentType}
        title="نوع پرداخت رو انتخاب کنید"
        trigger="click"
      >
        <button className={home.deptBtnPayHolder}>
          پرداخت {separate(item?.amount)} تومان
        </button>
      </Popover>
    </>
  );
};

export default Installments;
